// extracted by mini-css-extract-plugin
module.exports = {"overlay":"styles_overlay__G1S0v"};